// CampaignHeader.tsx
import React from 'react';
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import type { Campaign } from 'c-sdk';
import { CampaignThumbnail } from 'c-main/Components';

type Props = {
    campaign: Campaign;
    isMobileView: boolean;
    handleToggleDrawer: () => void;
};

const CampaignHeader: React.FC<Props> = ({ campaign, isMobileView, handleToggleDrawer }) => (
    <Box
        sx={{
            bgcolor: 'background.paper',
            pl: 2,
            pr: 2,
            position: 'relative',
            pt: isMobileView ? 8 : 2,
        }}
    >
        {isMobileView && (
            <IconButton onClick={handleToggleDrawer} size="small" aria-label="close">
                <ArrowBackIos />
            </IconButton>
        )}

        <Stack alignItems="center" gap={1} sx={{ mb: 2 }}>
            <CampaignThumbnail campaign={campaign} size={100} preferredSize="medium" rounded />
            <Typography
                align="center"
                variant="h6"
                sx={{
                    px: 1,
                    whiteSpace: 'normal',
                    overflowWrap: 'anywhere',
                    wordBreak: 'break-word',
                }}
            >
                {campaign?.name}
            </Typography>
            <Typography
                align="center"
                variant="body2"
                color="text.secondary"
                sx={{ fontWeight: 600 }}
            >
                #{campaign?.id}
            </Typography>
        </Stack>
        <Divider sx={{ mx: 'auto', borderColor: '#CCC' }} />
    </Box>
);

export default CampaignHeader;
